<template>
<div class="container">
    <div class="row mt-2">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Home'"/>
        </div>
        <div class="col-md-12 text-center">
            <h1 class="bold300 text-uppercase" style=" font-weight:500;">
                Proyectos de Desarrollo Regional
            </h1>
        </div>
        <div v-if="dataDesarrolloRegional" class="col-md-12">
             <card-collapse-docs :collapse="false" :sections="dataDesarrolloRegional" :urlServe="urlServe"/>
        </div>
    </div>
        <span v-html="fecha_actualizacion"></span>
</div>
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import mixin from "@/mixins/mixin.js";
import RecursosMunicipios from "@/services/rendicionDeCuentas/recursosMunicipios/recursosMunicipios.js"
const recursosMunicipios_Service = new RecursosMunicipios();
import botonAtras from '../../button-atras'
import DateFormat from "@/mixins/dateFormatMixin.js";

import cardCollapseDocs from '../../../components/cardCollapseDocs.vue';

export default{
    components:{botonAtras, cardCollapseDocs},
    data(){
        return{
            dataDesarrolloRegional: [],
            fecha_actualizacion:''
        };
    },
    async created(){
        this.getDesarrolloRegional();
        window.scrollTo(0, 0);
    },
    mixins:[mixin, DateFormat],
    methods:{
        async getDesarrolloRegional(){
            try {
                const response = await recursosMunicipios_Service.getProyectosDesarrolloRegional(mapFun.proyectosDesarrolloRegional);
                this.dataDesarrolloRegional = response;
                let fecha_texto = this.dataDesarrolloRegional[0].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                console.log('data ', this.dataDesarrolloRegional)
            } catch (error) {
                console.log('error vista', error.message);
            }
        }
    }
}
</script>
